// https://github.com/firebase/firebase-js-sdk/blob/55f3f83a7f2ed444f9880e1284f37c667532d13b/packages/auth/src/platform_react_native/persistence/react_native.ts#L35
// Define ReactNativeAsyncStorage interface locally
import { Persistence, PersistenceInternal, PersistenceType, PersistenceValue, STORAGE_AVAILABLE_KEY, StorageEventListener } from "./reactNativeAsyncStorageTypes";

export interface IReactNativeAsyncStorage {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
}

export type ReactNativeAsyncStorage = IReactNativeAsyncStorage;

export function getReactNativePersistence(storage: ReactNativeAsyncStorage): Persistence {
  return class implements PersistenceInternal {
    static type: "LOCAL" = "LOCAL";
    readonly type: PersistenceType = PersistenceType.LOCAL;

    async _isAvailable(): Promise<boolean> {
      try {
        if (!storage) return false;
        await storage.setItem(STORAGE_AVAILABLE_KEY, "1");
        await storage.removeItem(STORAGE_AVAILABLE_KEY);
        return true;
      } catch {
        return false;
      }
    }

    _set(key: string, value: PersistenceValue): Promise<void> {
      console.debug("getReactNativePersistence.set", key, value);
      if (!storage || typeof storage.setItem !== "function") {
        return Promise.resolve();
      }
      return storage.setItem(key, JSON.stringify(value));
    }

    async _get<T extends PersistenceValue>(key: string): Promise<T | null> {
      if (!storage || typeof storage.getItem !== "function") {
        return null;
      }
      const json = await storage.getItem(key);
      console.debug("getReactNativePersistence.get", key, json);
      return json ? JSON.parse(json) : null;
    }

    _remove(key: string): Promise<void> {
      if (!storage || typeof storage.removeItem !== "function") {
        return Promise.resolve();
      }
      return storage.removeItem(key);
    }

    _addListener(_key: string, _listener: StorageEventListener): void {
      // Listeners not supported for React Native storage
    }

    _removeListener(_key: string, _listener: StorageEventListener): void {
      // Listeners not supported for React Native storage
    }
  };
}
